/**
 * Component: count down timer
 * ------------------------------------------------------------------------------
 * Used in PDP with products that has made-to-order(mto) tag
 *
 * @namespace countDown
 */
import parseDate from '~/helpers/parseDate';
import cssClasses from '~/helpers/cssClasses';
import { applyTimeZoneOffset } from '@shopify/dates';
const centralTimezone = 'Europe/Madrid';
/**
 * DOM selectors.
 */

const selectors = {
  container: '[js-count-down="container"]'
};
/**
 * Create a countdown instance.
 *
 */

export default (() => {
  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    container: document.querySelector(selectors.container)
  };
  /**
   * Initialise component.
   */

  function init(element) {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const endDate = parseDate(nodeSelectors.container.getAttribute('data-end-date'));
    const formattedEndDate = new Date(endDate);
    const offsetDate = applyTimeZoneOffset(formattedEndDate, centralTimezone, userTimeZone);
    displayCountDown(offsetDate, element);
  }
  /**
   * Start countdown.
   * @param {Integer} endDateTimeUnix - end date of the product's made-to-order in unix.
   */


  function displayCountDown(date, element) {
    const countDown = setInterval(() => {
      const now = new Date().getTime(); // Find the distance between now and the count down date

      const distance = date - now; // Time calculations for days, hours, minutes and seconds

      const dayInMilliseconds = 1000 * 60 * 60 * 24;
      const hourInMilliseconds = 1000 * 60 * 60;
      const minutesInMilliseconds = 1000 * 60;
      const days = Math.floor(distance / dayInMilliseconds);
      const hours = Math.floor(distance % dayInMilliseconds / hourInMilliseconds);
      const minutes = Math.floor(distance % hourInMilliseconds / minutesInMilliseconds);
      const seconds = Math.floor(distance % minutesInMilliseconds / 1000);

      if (distance > 0) {
        element.innerHTML = "\n          <span class=\"body-1\">\n            ".concat(days, "d : ").concat(hours, "h : ").concat(minutes, "m : ").concat(seconds, "s</span>\n        ");
      } else {
        clearInterval(countDown);
        element.classList.add(cssClasses.disabled);
        element.innerHTML = '<span class="body-1">Expired</span>';
      }
    }, 1000);
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    init
  });
});